import React from 'react'
import { BulkDeleteWithConfirmButton } from 'react-admin'

export const DatagridBulkActionButtonsCustom = () => {
  return <BulkDeleteWithConfirmButton mutationMode="pessimistic" />
}
